/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Illegal_TitleInputs */

const en_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illegal character detected (non 608)`)
};

const fr_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractère illégal détecté (non 608)`)
};

const de_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiges Zeichen erkannt (nicht 608)`)
};

const it_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carattere illegale rilevato (non 608)`)
};

const ru_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружен недопустимый символ (не 608).`)
};

const es_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carácter ilegal detectado (distinto del 608)`)
};

const zh_cn2_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测到非法字符（非 608）`)
};

const ja_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正な文字が検出されました（608以外）`)
};

const hi_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवैध वर्ण का पता चला (गैर 608)`)
};

const pt_pt2_event_warning_illegal_title = /** @type {(inputs: Event_Warning_Illegal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractere ilegal detectado (diferente de 608)`)
};

/**
* | output |
* | --- |
* | "Illegal character detected (non 608)" |
*
* @param {Event_Warning_Illegal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_illegal_title = /** @type {((inputs?: Event_Warning_Illegal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Illegal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_illegal_title(inputs)
	if (locale === "de") return de_event_warning_illegal_title(inputs)
	if (locale === "it") return it_event_warning_illegal_title(inputs)
	if (locale === "ru") return ru_event_warning_illegal_title(inputs)
	if (locale === "es") return es_event_warning_illegal_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_illegal_title(inputs)
	if (locale === "ja") return ja_event_warning_illegal_title(inputs)
	if (locale === "hi") return hi_event_warning_illegal_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_illegal_title(inputs)
	return en_event_warning_illegal_title(inputs)
});